import { ActiveScriptCardUnit, PassStep } from '@/models/scripts'

export interface ActiveScriptState {
  scriptId?: string
  cardNumber?: number
  started?: number
  history?: PassStep[]
  cards?: ActiveScriptCardUnit[]
}

export const initialState: ActiveScriptState = {
  scriptId: undefined,
  cardNumber: undefined,
  started: undefined,
  history: undefined,
  cards: undefined,
}
